import { useContext } from 'react';
import { QBItemProp, QBType } from '@/components/query-builder/models';
import { EditorContext } from '@/features/editor/context/editor-context';
import { SelectOptions } from '@/components/small-select';
import { getProductValue } from '@/features/editor/widgets/shared/modals/use-audience-query-builder';

export function useMatchRules() {
  const { resources } = useContext(EditorContext);

  const tags = resources?.tags?.map?.(
    (tag) =>
      ({
        key: tag,
        value: tag,
      } as SelectOptions),
  );

  const collections = resources?.collections?.map?.(
    (col) =>
      ({
        key: col.handle,
        value: col.title,
      } as SelectOptions),
  );

  const condition: QBItemProp[] = [
    {
      kind: QBType.ARRAY_VALUE,
      caption: `products with tag`,
      options: tags,
      envKey: `tag`,
    },
    {
      envKey: `category`,
      kind: QBType.MULTI_VALUE,
      caption: `products from collections`,
      options: collections,
    },
    {
      kind: QBType.ARRAY_VALUE,
      caption: `Product Name`,
      options: resources?.products?.map(
        (p) =>
          ({
            key: p.handle,
            image: p?.image?.src,
            value: getProductValue(p),
          } as SelectOptions),
      ),
      defaultIsNot: true,
      envKey: `product`,
    },
  ];

  return {
    condition,
  };
}
